/**
* v-dialogDrag 弹窗拖拽
* xiaobu
*/

export const dialogDrag = {
  bind: (el, binding, vnode, oldVnode) => {
    const value = binding.value
    if (value === false) { return }
    // 获取拖拽内容头部
    const dialogHeaderEl = el.querySelector(".el-dialog__header")
    const dragDom = el.querySelector(".el-dialog")
    dialogHeaderEl.style.cursor = "move"
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    dragDom.style.position = "absolute"
    dragDom.style.marginTop = value
    let width = dragDom.style.width
    if (width.includes("%")) {
      // eslint-disable-next-line
      width = +document.body.clientWidth * (+width.replace(/\%/g, "") / 100)
    } else {
      width = +width.replace(/\px/g, "")
    }
    dragDom.style.left = `${(document.body.clientWidth - width) / 2}px`
    // 鼠标按下事件
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离 (鼠标点击位置距离可视窗口的距离)
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes("%")) {
        // eslint-disable-next-line
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100)
        // eslint-disable-next-line
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100)
      } else {
        styL = +sty.left.replace(/\px/g, "")
        styT = +sty.top.replace(/\px/g, "")
      }

      // 鼠标拖拽事件
      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离 （开始拖拽至结束拖拽的距离）
        const l = e.clientX - disX
        const t = e.clientY - disY

        const finallyL = l + styL
        const finallyT = t + styT

        // 移动当前元素
        dragDom.style.left = `${finallyL}px`
        dragDom.style.top = `${finallyT}px`

      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}

/**
* v-dialogDragHeight 可拖动弹窗高度（右下角）
* xiaobu
*/

export const dialogDragHeight = {
  bind(el) {
    const dragDom = el.querySelector(".el-dialog")
    const lineEl = document.createElement("div")
    lineEl.style = "width: 6px; background: inherit; height: 10px; position: absolute; right: 0; bottom: 0; margin: auto; z-index: 1; cursor: nwse-resize;"
    lineEl.addEventListener("mousedown",
      function(e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - el.offsetLeft
        const disY = e.clientY - el.offsetTop
        // 当前宽度 高度
        const curWidth = dragDom.offsetWidth
        const curHeight = dragDom.offsetHeight
        document.onmousemove = function(e) {
          e.preventDefault() // 移动时禁用默认事件
          // 通过事件委托，计算移动的距离
          const xl = e.clientX - disX
          const yl = e.clientY - disY
          dragDom.style.width = `${curWidth + xl}px`
          dragDom.style.height = `${curHeight + yl}px`
        }
        document.onmouseup = function(e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }, false)
    dragDom.appendChild(lineEl)
  }
}

/**
* v-dialogDragWidth 可拖动弹窗宽度（右侧边）
* xiaobu
*/

export const dialogDragWidth = {
  bind(el) {
    const dragDom = el.querySelector(".el-dialog")
    const lineEl = document.createElement("div")
    lineEl.style = "width: 5px; background: inherit; height: 80%; position: absolute; right: 0; top: 0; bottom: 0; margin: auto; z-index: 1; cursor: w-resize;"
    lineEl.addEventListener("mousedown",
      function(e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - el.offsetLeft
        // 当前宽度
        const curWidth = dragDom.offsetWidth
        document.onmousemove = function(e) {
          e.preventDefault() // 移动时禁用默认事件
          // 通过事件委托，计算移动的距离
          const l = e.clientX - disX
          dragDom.style.width = `${curWidth + l}px`
        }
        document.onmouseup = function(e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }, false)
    dragDom.appendChild(lineEl)
  }
}